import { createGetAPI, createGetAllAPI, createPatchAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';

import { BASE_URL } from '../constants/api';

// Teacher search for the preferred-teacher control (ACT/FDTR only, band embedded)
// — mirrors the "Assign a teacher" search in the Create Payment Link flow.
const { useGetAll: useTeacherSearchGetAll } = createGetAllAPI({
  getURL: query => `${BASE_URL}/teachers/?${stringify(query)}`,
});

// Read-only visibility for the admin panel (open to all staff): is_admissions_case,
// the exact post-trial plans the parent sees on leap, effective defaults, current
// overrides, and whether the caller may write.
const {
  useGet: usePaymentFlowOverridesViewGet,
  invalidate: invalidatePaymentFlowOverridesView,
} = createGetAPI({
  getURL: studentId => `${BASE_URL}/students/${studentId}/payment-flow-overrides/`,
});

// Write (allow-listed few): merges the supplied toggles; `reason` is required.
const { usePatch: usePaymentFlowOverridesPatch } = createPatchAPI({
  getURL: studentId => `${BASE_URL}/students/${studentId}/payment-flow-overrides/`,
});

export {
  usePaymentFlowOverridesViewGet,
  invalidatePaymentFlowOverridesView,
  usePaymentFlowOverridesPatch,
  useTeacherSearchGetAll,
};
